import PropTypes from 'prop-types';
import React, { createContext, useCallback, useContext, useState } from 'react';

const SidebarContext = createContext();

const firstRenderCollapsed = () => {
  return document?.body?.clientWidth < 992;
};

function SidebarProvider ({ closeByDefault, ...rest }) {
  const [collapsed, setCollapsed] = useState(closeByDefault || firstRenderCollapsed());
  const toggleCollapsed = useCallback(() => setCollapsed(prevState => !prevState), [setCollapsed]);
  
  return (
    <SidebarContext.Provider value={{
      collapsed,
      setCollapsed,
      toggleCollapsed
    }} {...rest} />
  );
}

function useSidebar () {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebarContext must be used within a SidebarContextProvider');
  }
  const {
    collapsed,
    setCollapsed,
    toggleCollapsed
  } = context;
  
  return {
    collapsed,
    setCollapsed,
    toggleCollapsed
  };
}

SidebarProvider.propTypes = {
  closeByDefault: PropTypes.bool
};

SidebarProvider.defaultProps = {
  closeByDefault: false
};

export { SidebarProvider, useSidebar };
